























































































import { Component, Vue, Provide } from "vue-property-decorator";
import { ticketClient } from "@/api/index";
import {
  ListMultilingualDetailReq,
  SaveMultilingualDetailReq,
  ListPushTemplateReq
} from "@/pbjs/external/ticket/ticket_pb";
import { setCommon, errorMsg } from "@/utils/request";

@Component({
  name: "MultilingualContent",
})
export default class MultilingualContent extends Vue {   
    @Provide() private languagekey:any = ''; // 标题
    @Provide() private description:any = ''; // 描述
    @Provide() private tasktag:any = ''; // 标签
    @Provide() private status:any = ''; // 多语言状态
   
    @Provide() private positionArr:any = [];
    @Provide() private blurIndex:any = null ;
    @Provide() private curInputValue: any = null; // 当前textarea的值
    @Provide() private curContentId: any = '1'; // 当前编辑内容ID
    @Provide() private isEdit: boolean = false;
    @Provide() private isAddNewItem: boolean = false;
    @Provide() private curLanguage: string = ''; // 当前语言
    @Provide() private languageOption: any = [
        {label: "English",value: "en-US",},
        {label: "Spanish", value: 'es-MX'},
        {label: "Indonesian", value: 'id-ID'},
    ];
    @Provide() private resultData: any = [];
    @Provide() private taskTag: any = ['sms', 'push', 'whatsapp'];
    @Provide() private tagNumber: any = [];
    @Provide() private varLibrary: any = [];
    private created() {
      this.languagekey = this.$route.query.langKey;
      this.description = this.$route.query.description;
      this.status = this.$route.query.status;
      this.tasktag = this.$route.query.tag;
      this.getListMultilingualDetail();
      this.getVarList();
    }
    private languageChange(val:any) {
      this.curLanguage = val;
    }
    private getVarList() {
      let request: any = new ListPushTemplateReq();
      request.setCommonin(setCommon());
      for (var i = 0; i < this.tagNumber.length; i++) {
        request.setTasktag(this.tagNumber[i]);
      }
      console.log('ListPushTemplateReq',request);
      ticketClient.listPushTemplate(request, {}, (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          console.log('ListMultilingualresponse:', data);
          if (!data.commonout || data.commonout.code == 0) {
            this.varLibrary = data.listList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
      });
    }
    private onInput(e:any) {
      let val = e.target.value;
      let d_index = e.srcElement.selectionStart;
      let onInVal = val.substring(d_index-1, d_index);
      console.log('input事件监听的val：', e.target.value, '123:', onInVal);
      if(val.length > this.curInputValue.length) {
        // 判断用户在两个花括号之间输入文字
        let curPositionArr:any = [];
        val.replace(/\{{.*?\}}/g, function(rs:any,offset:any,source:any) {
          let obj = {
            posStart: offset,
            posEnd: offset + rs.length
          }
          curPositionArr.push(obj);
        })
        let initPositionArr:any = [];
        this.curInputValue.replace(/\{{.*?\}}/g, function(rs:any,offset:any,source:any) {
          let obj = {
            posStart: offset,
            posEnd: offset + rs.length
          }
          initPositionArr.push(obj);
        })
        let isBroken = curPositionArr.length < initPositionArr.length;        
        if(onInVal === '{' || onInVal === '}' || isBroken) {
          this.curInputValue = val.substring(0, d_index-1) + val.substring(d_index); // 判断禁止输入花括号字符
          setTimeout(()=>{
            this.setInputValue();
          }, 100);
        } else {
          this.curInputValue = val;
          this.setInputValue();
        }
      }
    }
    private handleDelete(event:any) {
      let newArr:any = [];
      this.curInputValue.replace(/\{{.*?\}}/g, function(rs:any,offset:any,source:any) {
        let obj = {
          posStart: offset,
          posEnd: offset + rs.length
        }
        newArr.push(obj);
      })
      this.positionArr = newArr;
      let delIndex = event.srcElement.selectionStart + 1;
      let curVaule = event.target.value;
      console.log(this.positionArr, 'this.positionArrthis.positionArrthis.positionArr', this.curInputValue)
      if(this.positionArr.length) {
        let isInArea = false;
        this.positionArr.forEach((item:any) => {
          if(delIndex > item.posStart && delIndex <= item.posEnd) {
            let allFrontStr = curVaule.substring(0, item.posStart)
            let allBackStr = curVaule.substring(item.posEnd-1)
            this.curInputValue = allFrontStr + allBackStr;
            this.setInputValue();
            isInArea = true;
          }
        }) 
        if(!isInArea) {
          this.curInputValue = curVaule;
        }
      }
    }
    private handleInputBlur( e:any ) {
      this.blurIndex = e.srcElement.selectionStart;
      this.curInputValue = e.target.value;
      console.log(this.blurIndex, 'this.blurIndex')
      console.log(this.curInputValue, 'this.curInputValue')
    } 
    private insertVariable(tag:any) {
      let index = this.blurIndex;
      let str = this.curInputValue || '';
      this.curInputValue = str.slice(0, index) + tag + str.slice(index);
      this.setInputValue();      
      console.log(this.curInputValue, 'this.curInputValue')
    } 
    private setInputValue () {
      if(this.curContentId) {
        let arr = this.resultData;
        arr.forEach((item:any, index:any) => {
          if(item.id === this.curContentId) {
            console.log(this.curInputValue, 'ppppppppppp')
            item.languagevalue = this.curInputValue
          }
          return item;
        })
      } else {
        this.resultData.forEach((item:any) => {
          if(!item.id) {
            item.languagevalue = this.curInputValue
          }
          return item;
        })
      }
    }
    private addNewItem() {
      if(this.resultData.length === 0) {
        // if(this.isAddNewItem) {    
        //   return;
        // }
        this.isAddNewItem = true;
        this.curContentId = '';
        this.curInputValue = '';
        this.curLanguage = '';
        this.resultData.unshift({language: '', languagevalue: '', id: ''});
      } else {
        this.$message({
          message: "Only one can be added！",
          type: "warning",
        });
        return;
      }
    } 

    private editListMultilingualDetail(item:any) {
      console.log(item, '123123');
      this.isEdit = true;
      this.curContentId = item.id;      
      this.curLanguage = item.language;
      this.curInputValue = item.languagevalue;
      this.resultData.forEach((citem:any) => {
        citem.disabled = true;
        if(item.id === citem.id) {
          citem.disabled = false;
        }    
      })
        console.log(this.resultData, 'this.editediteditData')
    }
    
    private getListMultilingualDetail() {
      let request: any = new ListMultilingualDetailReq();
      request.setCommonin(setCommon());
      request.setLanguagekey(this.languagekey);
     
      console.log('ListMultilingualDetailReq',request);
      ticketClient.listMultilingualDetail(request, {}, (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          console.log('ListMultilingualresponse:', data);
          if (!data.commonout || data.commonout.code == 0) {
            let editData:any = [];
            data.listList.map((item:any) => {
              editData.push(
                {
                  id: item.id,
                  language: item.language,
                  languagevalue: item.languagevalue,
                  disabled: true
                }
              )     
            })
            this.resultData = editData
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
      });
    }
    // 新增/编辑多语言内容
    private saveListMultilingualDetail() {
      if(this.isEdit || this.isAddNewItem) {
        let request: any = new SaveMultilingualDetailReq();
        request.setCommonin(setCommon());
        request.setId(this.curContentId);
        request.setLanguagekey(this.languagekey);
        request.setLanguagevalue(this.curInputValue);
        request.setLanguage(this.curLanguage);
       
        console.log('SaveMultilingualDetailReq',request);
        ticketClient.saveMultilingualDetail(request, {}, (err: any, response: any) => {
          if (response) {
            let data: any = response.toObject();
            console.log('saveMultilingualDetail:', data);
            if (!data.commonout || data.commonout.code == 0) {
              this.$message({
                message: "submit successfully",
                type: "success",
              });
              this.curContentId = '';
              this.isEdit = false;
              this.isAddNewItem = false;
              this.getListMultilingualDetail();
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          }
          if (err) {
            errorMsg(err);
          }
        });
      } else {
        this.$message({
          message: "please edit!",
          type: "warning",
        });
      }
    } 

}

